import { ObservableMap } from '@stencil/store';
import {
    ApolloThemeType,
    getCachedTheme,
    isBrowserIE,
    ThemeType,
} from '@uipath/portal-shell-util';

import {
    isFalselyOrWhiteSpace,
    setActiveLogoUrl,
} from '../store/common';
import { State } from '../store/types/state';
import Logger from './logger/logger';

function getDarkMediaQueryList(): MediaQueryList {
    return window.matchMedia('(prefers-color-scheme: dark)');
}

function handleThemeMediaChange(store: ObservableMap<State>) {
    return (e: MediaQueryListEvent): void => {
        setApolloTheme(store, e.matches ? 'dark' : 'light');
    };
}

export function addThemeMediaListener(store: ObservableMap<State>) {
    if (!isBrowserIE()) {
        const darkMediaQueryList = getDarkMediaQueryList();
        if (darkMediaQueryList.addEventListener) {
            darkMediaQueryList.addEventListener('change', handleThemeMediaChange(store));
        }
    }
}

export function removeThemeMediaListener(store: ObservableMap<State>) {
    if (!isBrowserIE()) {
        const darkMediaQueryList = getDarkMediaQueryList();
        if (darkMediaQueryList.removeEventListener) {
            darkMediaQueryList.removeEventListener('change', handleThemeMediaChange(store));
        }
    }
}

export function getTheme(store: ObservableMap<State>, override: ThemeType = 'autoTheme') {
    const apolloTheme = store.get('theme') || getCachedTheme();
    const shouldUseOverride = override !== 'autoTheme';
    return {
        dark: shouldUseOverride ? override === 'dark' : apolloTheme === 'dark',
        light: shouldUseOverride ? override === 'light' : apolloTheme === 'light',
    };
}

export function setApolloTheme(store: ObservableMap<State>, apolloTheme: ApolloThemeType) {
    if (isFalselyOrWhiteSpace(apolloTheme)) {
        return;
    }

    store.set('theme', apolloTheme);
    Logger.info('store', `theme has changed: ${apolloTheme}`);

    // update body class list based on theme.
    // note this works only for angular and not for react
    document.body?.classList?.remove('light', 'dark');
    document.body?.classList?.add(apolloTheme);

    // update logo url with selected theme
    const account = store.get('account')!;
    setActiveLogoUrl(store, account, apolloTheme);
}
